var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 452,
    viewBox: "0 0 330 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 90.3486,
    width: 323.539,
    height: 90.3486,
    fill: "#66BFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.8858C3 6.21688 9.21688 0 16.8858 0L312.653 0C320.322 0 326.539 6.21688 326.539 13.8858V90.3486L3 90.3486L3 13.8858Z",
    fill: "#287CA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.00006,
    y: 175.383,
    width: 323.539,
    height: 90.3486,
    fill: "#536FED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 265.731,
    width: 323.539,
    height: 90.3486,
    fill: "#493CC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00006 356.08L326.539 356.08V432.542C326.539 440.211 320.322 446.428 312.653 446.428H16.8859C9.21696 446.428 3.00006 440.211 3.00006 432.542L3.00006 356.08Z",
    fill: "#3D2F76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_3",
    x: 0.222841,
    y: 0,
    width: 329.093,
    height: 451.983,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.77716
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_3",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.80054fc8b96c5a2302521bc6f16a62fc.svg";
export { ForwardRef as ReactComponent };